import React from 'react';
import MessageRenderer from './MessageRenderer';

const ChartTest = () => {
  // Sample finalOutput with chart data
  const sampleFinalOutput = `# Sales Report

Here's our quarterly sales analysis:

\`\`\`chart
{
  "type": "bar",
  "data": {
    "labels": ["Q1", "Q2", "Q3", "Q4"],
    "datasets": [{
      "label": "Revenue (in thousands)",
      "data": [120, 190, 300, 250],
      "backgroundColor": "rgba(54, 162, 235, 0.5)",
      "borderColor": "rgba(54, 162, 235, 1)",
      "borderWidth": 1
    }]
  },
  "options": {
    "plugins": {
      "title": {
        "display": true,
        "text": "Quarterly Revenue 2024"
      }
    },
    "scales": {
      "y": {
        "beginAtZero": true,
        "title": {
          "display": true,
          "text": "Revenue ($000)"
        }
      }
    }
  }
}
\`\`\`

The chart above shows strong growth in Q3, with a slight decline in Q4.

## Multiple Charts Example

Here's another chart showing user engagement:

\`\`\`chart
{
  "type": "bar",
  "data": {
    "labels": ["Jan", "Feb", "Mar", "Apr", "May"],
    "datasets": [{
      "label": "Active Users",
      "data": [1200, 1900, 3000, 2500, 2800]
    }]
  },
  "options": {
    "plugins": {
      "title": {
        "display": true,
        "text": "Monthly Active Users"
      }
    }
  }
}
\`\`\`

Both charts are interactive - hover over the bars to see detailed values!`;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Chart.js Integration Test</h1>
      <p>This page demonstrates the Chart.js integration with MessageRenderer component.</p>
      
      <div style={{ border: '1px solid #ddd', padding: '20px', borderRadius: '8px', marginTop: '20px' }}>
        <MessageRenderer 
          finalOutput={sampleFinalOutput}
          userId="test-user"
        />
      </div>

      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h2>Usage Instructions</h2>
        <p>To use charts in your finalOutput, wrap your Chart.js configuration JSON in <code>```chart</code> and <code>```</code> blocks:</p>
        <pre style={{ backgroundColor: '#fff', padding: '10px', borderRadius: '4px', overflow: 'auto' }}>
{`\`\`\`chart
{
  "type": "bar",
  "data": {
    "labels": ["A", "B", "C"],
    "datasets": [{
      "label": "Sample Data",
      "data": [10, 20, 30]
    }]
  }
}
\`\`\``}
        </pre>
      </div>
    </div>
  );
};

export default ChartTest;
